<template>
  <div class="login ivu-article" @keydown.enter="handleSubmit">
    <div class="login-con">
      <Card :bordered="false">
        <p slot="title" style="text-align: center;font-size: 16px">
          <Icon type="log-in"></Icon>
          欢迎登录经贸活动云
        </p>
        <div class="form-con">
          <Form ref="loginForm" size="large" :model="form" :rules="rules">
            <FormItem prop="userName">
              <Input v-model="form.userName" size="large" placeholder="请输入用户名">
              <span slot="prepend">
                <Icon :size="16" type="ios-person"></Icon>
              </span>
              </Input>
            </FormItem>
            <FormItem prop="password">
              <Input type="password" v-model="form.password" size="large" placeholder="请输入密码">
              <span slot="prepend">
                <Icon :size="14" type="md-lock"></Icon>
              </span>
              </Input>
            </FormItem>
            <FormItem>
              <Button @click="handleSubmit" size="large" type="primary" long>登  录</Button>
            </FormItem>
            <Alert v-show="showErrorMsg" type="error" show-icon>{{ errorMsg }}</Alert>
<!--              <a href="/api/admin/meetings/file/download?path=doc/bizevent_instructions.docx&fileName=活动云管理系统使用说明.docx"><Icon type="ios-cloud-download-outline" size="16"/>下载系统使用说明书</a>-->
          </Form>
<!--          <div class="other-login-type">-->
<!--            <div class="css-t703mf"></div>-->
<!--            <div class="css-daoszp">其他方式登录</div>-->
<!--            <div class="css-t703mf"> </div>-->
<!--          </div>-->
<!--          <div>-->
<!--            <a style="color:#024298" href="/api/admin/oauth/dpt">-->
<!--              <img src="../assets/ccpit-logo.png" style="width: 40px;vertical-align: middle;" /> -->
<!--              <span style="font-weight: 500; font-size: 14px">贸促会统一身份登录</span></a> -->
<!--          </div>-->

        </div>
      </Card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      form: {
        userName: '',
        password: ''
      },
      errorMsg: '',
      showErrorMsg: false,
      rules: {
        userName: [
          {required: true, message: '账号不能为空', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '密码不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    async doLogin () {
      this.$Loading.start()
      try {
        await this.$store.dispatch('login', {name: this.form.userName, password: this.form.password})
        this.$router.replace(this.$route.query.redirect || '/meetings/list')
      } catch (e) {
        this.errorMsg = (e.body.error || '登录失败')
        this.showErrorMsg = true
      } finally {
        this.$Loading.finish()
      }
    },
    handleSubmit () {
      this.showErrorMsg = false
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.doLogin()
        }
      })
    }
  },
  mounted () {
    let errorCode = this.$route.query.errorCode
    if (errorCode !== undefined && errorCode != null) {
      if (errorCode === '1') {
        this.$Modal.error({
          title: '登录失败',
          content: '请稍后重试。',
          onOk: () => {
            this.$router.replace('/login')
          }
        })
      } else if (errorCode === '2') {
        this.$Modal.info({
          title: '您还没有开通经贸活动云',
          content: '请致电010-82217954申请开通。',
          onOk: () => {
            this.$router.replace('/login')
          }
        })
      } else if (errorCode === '3') {
        this.$Modal.error({
          title: '登录失败',
          content: '未同意授权',
          onOk: () => {
            this.$router.replace('/login')
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .login {
    width: 100%;
    height: 100%;
    background-image: url(../assets/login-bg.jpg);
    background-size: cover;
    background-position: center;
    position: relative;
    .login-con {
      position: absolute;
      right: 160px;
      top: 50%;
      transform: translateY(-60%);
      width: 330px;
      .login-header {
        font-size: 16px;
        font-weight: 300;
        text-align: center;
        padding: 30px 0;
      }
      .form-con {
        padding: 10px 0 0;
      }
      .login-tip {
        font-size: 10px;
        text-align: center;
        color: #c3c3c3;
      }
      .other-login-type {
        box-sizing: border-box;
        margin: 0;
        min-width: 0;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        margin: 0 0 12px 0;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;

        .css-t703mf {
          box-sizing: border-box;
          margin: 0;
          min-width: 0;
          border-top: 1px solid;
          border-color: #EBEBEB;
          width: 79px;
        }
        .css-daoszp {
          box-sizing: border-box;
          margin: 0;
          min-width: 0;
          color: #999999;
          font-size: 12px;
          margin-left: 16px;
          margin-right: 16px;
          width: 72px;
          overflow: hidden;
          line-height: 17px;
          white-space: nowrap;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Login.vue